import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-884641f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container contact-us-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "main"
}
const _hoisted_3 = { class: "text-box" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["innerHTML"]

import { reactive, ref } from 'vue';
  import { FormItem  } from '@/types/form';
  import { Responses  } from '@/types/responses';
  import { request, alert, getQuestions, getAnswers } from '@/utils';
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const form = reactive({
    g_recaptcha_response: ''
  });
  const title = ref('');
  const desc = ref('');
  const surveyId = ref('');
  const formList = reactive<(FormItem[])>([])!;

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  async function getContactUs() {
    const { data } = await request.get('/surveys/contact_us');
    surveyId.value = data.id;
    title.value = data.title;
    desc.value = data.desc;
    Array.prototype.push.apply(formList, getQuestions(data));
    formList.push({
      label: t('CAPTCHA'),
      type: 'custom',
      required: true,
      placeholder: t('Captcha'),
      key: 'g_recaptcha_response',
      inputType: 'text',
    });
  }

  async function handleSubmit() {
    const answers = getAnswers(form, formList);
    // 移除验证码answer
    answers.pop();
    const body: Responses = {
      survey_id: Number(surveyId.value),
      type: 'SpecifyResponse',
      answers_attributes: answers,
      g_recaptcha_response: form.g_recaptcha_response
    };
    try {
      await request.post('responses', body);
      alert({ title: t('Success'), content: t('Operation success'), });
      Object.keys(form).forEach(key => {
        form[key] = null;
      });
    } finally {
      form.g_recaptcha_response = '';
    }
  }

  getContactUs();

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_GoogleRecaptcha = _resolveComponent("GoogleRecaptcha")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, {
      routes: [{name: _unref(t)('Home'), to: {name: 'home'}}, {name: _unref(t)('Contact Us'), to: {name: 'contactUs'}}]
    }, null, 8, ["routes"]),
    (surveyId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(title.value), 1),
            _createElementVNode("div", {
              class: "desc",
              innerHTML: desc.value
            }, null, 8, _hoisted_5)
          ]),
          _createVNode(_component_b_form, {
            class: "form-box",
            onSubmit: handleSubmit
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formList), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.key,
                  class: "form-group-item"
                }, [
                  _createVNode(_component_AppFormGroupItem, {
                    config: item,
                    form: _unref(form),
                    onChange: formItemChange
                  }, _createSlots({ _: 2 }, [
                    (item.key === 'g_recaptcha_response')
                      ? {
                          name: "custom",
                          fn: _withCtx(() => [
                            _createVNode(_component_GoogleRecaptcha, {
                              modelValue: _unref(form)['g_recaptcha_response'],
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form)['g_recaptcha_response']) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        }
                      : undefined
                  ]), 1032, ["config", "form"])
                ]))
              }), 128)),
              _createVNode(_component_b_button, {
                type: "submit",
                class: "submit-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Submission')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})